function Pagination(): any {
  return {
    MuiPagination: {
      defaultProps: {
        shape: 'rounded'
      }
    }
  };
}

export { Pagination };
